import type { AuthUser } from './api/auth'
import { activeManufacturer } from './tenant'

// MP-OS-193: the chat is closed to suppliers until it is stable and tested (Carl/Olof, 22 Oct
// 2026). Temporary, but deliberately not a flag: re-opening needs their decision and a reviewed
// change here. Hiding is only the UI half; POST /api/ask refuses every non-admin session itself.
// An admin's "View as supplier" mirrors the supplier view, so it hides the chat too (the server
// still serves the admin). Every chat entry point in the shell reads this one helper.
export function chatAvailable(user: Pick<AuthUser, 'role'> | null | undefined, previewingSupplier: boolean): boolean {
  return user?.role === 'admin' && !previewingSupplier
}

// The admin picker's scope: '' is the admin's own whole-market view, anything else is a preview.
export function previewingSupplier(): boolean {
  return activeManufacturer() !== ''
}
